import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import "../../MissionAndVission/MissionContact/MissionContact.css";

const BookYourNextAdventure = () => {
  return (
    <div>
       <div className="mission-contact">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <h1 className='headings contact-h1 text-white'><span className='contact-h1-span'>Join Us in</span> Shaping the Future of Corporate Travel</h1>
                            <p className='mission-contact-p'>Connect with us to experience travel solutions driven by purpose, passion, and principles.</p>
                            <div className="carouselCaption">
                                <a href="/contact">
                                    <button className="btn bg-transparent text-white mt-md-3 grotesk-headings">CONTACT US</button>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-image-m">
                            <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/mission-contact.png" alt=""  loading="lazy" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default BookYourNextAdventure
